import axios from "axios";
const URL = process.env.REACT_APP_API_URL;

export const userService = (userId: string) => {
  return axios.post(`${URL}/user/`, { userId });
};
